import React, {Component, FormEvent, useState} from 'react';
import {
  IonButtons,
  IonButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonInput,
  IonRow,
  IonCol,
  IonCheckbox,
  IonSegment,
  IonSegmentButton,
  IonTabs,
  IonTab,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonTabBar,
  IonTabButton,
  IonIcon
} from '@ionic/react';
import './Login.css';
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import _ from '../_';
import ReactHtmlParser from 'react-html-parser';
import {StaticEvent} from "../_/StaticEvent";
import {BaseComponent} from "./_/BaseComponent";


type State = {
  username?: string | null,
  password?: string | null,
  email?: string | null,
  userpassword?: string | null,
  selectedSegment: string;
}


export default class Login extends BaseComponent<{}, State> {
  static RoutePathname = /^\/login/gi;

  constructor(props: {}) {
    super(props);

    this.state = {
      selectedSegment: 'default'
    }
  }

  async logInDefault(e: any) {
    e.preventDefault();
    e.stopPropagation();

    // @ts-ignore
    const {username, password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    if (username && password) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        account: username,
        password: password,
      };
      const postUrl = ApiService.urlMapping('~/api/1/_login');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS
              let payload = data.payload;

              let processSuccess = async (redirAfterSuccess = true) => {
                let t_customer = payload.userEntity;
                let serverSessionId = payload.SessionID;

                await Static.storageService.setLoggedAsync(serverSessionId, JSON.stringify(t_customer));

                if (redirAfterSuccess) {
                  // @ts-ignore
                  this.props.history.push('/');
                }
              }

              if (payload.SuccessButMayWantToSignupPasswordValidation) {
                // @ts-ignore
                this.props.history.push('/FirstLoginLevel2')
                await processSuccess(false);
              } else if (payload.SuccessButMayWantToSignupFastLogin) {
                // @ts-ignore
                this.props.history.push('/poppage')
                await processSuccess(false);
              } else if (payload.RequireFurtherPasswordValidation) {
                // @ts-ignore
                this.props.history.push(`/CheckPassword?ContextToken=${encodeURIComponent(payload.ContextToken)}`)
              } else {
                await processSuccess();
              }

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }

  async logInFast_DeviceLockless(e: any) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // @ts-ignore
    //const {username, password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    let code = Static.storageService.getDeviceLocklessKey();


    if (code) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        code: code
      };
      const postUrl = ApiService.urlMapping('~/api/1/_loginfast/devicelockless');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS

              let t_customer = data.payload.userEntity;
              let serverSessionId = data.payload.SessionID;

              await Static.storageService.setLoggedAsync(serverSessionId, JSON.stringify(t_customer));


              // @ts-ignore
              this.props.history.push('/')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }

  async logInFast_Device(e: any) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (!await this.validateDeviceKey()) {
      return;
    }
    // @ts-ignore
    //const {username, password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    let code = Static.storageService.getDeviceKeyBase64();

    if (code) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        code: code
      };
      const postUrl = ApiService.urlMapping('~/api/1/_loginfast/device');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS

              let t_customer = data.payload.userEntity;
              let serverSessionId = data.payload.SessionID;

              await Static.storageService.setLoggedAsync(serverSessionId, JSON.stringify(t_customer));


              // @ts-ignore
              this.props.history.push('/')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }

  async unbindAll(e: any) {
    e.preventDefault();
    e.stopPropagation();

    if (confirm('將解除所有的綁定，包含指紋，設備。是否確定?')) {
      Static.storageService.setDeviceLocklessKey(null);
      Static.storageService.setDeviceKey(null);

      this.setState((prev) => {
        return prev;
      });
    }
  }

  handleInputChange(e) {
    // @ts-ignore
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleSegmentChange = (e: CustomEvent) => {
    this.setState({selectedSegment: e.detail.value});
  };


  updateUserName(e: CustomEvent) {
  }

  async logInAccount(e: any) {
    e.preventDefault();
    e.stopPropagation();

    // @ts-ignore
    const {email, userpassword} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    if (email && userpassword) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        account: email,
        password: userpassword,
        timezoneOffset: (new Date()).getTimezoneOffset() * 60 * 1000,
      };
      const postUrl = ApiService.urlMapping('~/api/1/_login2');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS

              let t_customer = data.payload.userEntity;
              let serverSessionId = data.payload.SessionID;

              await Static.storageService.setLoggedAsync(serverSessionId, JSON.stringify(t_customer));


              // @ts-ignore
              this.props.history.push('/')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }

  async validateDeviceKey() {
    try {
      let deviceKey = Static.storageService.getDeviceKey();

      const options = {
        allowCredentials: [{
          id: deviceKey,
          type: 'public-key'
        }],
        challenge: new Uint8Array([4, 5, 7, 8]),
      }

      const assertion: any = await navigator.credentials.get({
        publicKey: options
      } as any);

      //alert("Authenticated user" + new Uint8Array(assertion.response.userHandle)[0])
      return true;
    } catch (err) {
      alert(err);
      return false;
    }
  }

  signUpUser() {
  }

  render() {
    const {selectedSegment} = this.state;

    return (
      <>
        {ReactHtmlParser('<ion-toast-controller></ion-toast-controller>')}
        <div className="logo">
          <div className="ilogo"></div>
          <div className="plustitle">懷相工人雲端平台</div>
          <div className="main_logo">
            <div className="bx1"></div>
            <div className="bx2"></div>
            <div className="bx3"></div>
            <div className="bx4"></div>
            <div className="bx5"></div>
            <div className="bx6"></div>
            <div className="bx7"></div>
            <div className="bx8"></div>
            <div className="bx9"></div>
            <div className="bx10"></div>
            <div className="bx11"></div>
            <div className="bx12"></div>
            <div className="bx13"></div>
            <div className="bx14"></div>
            <div className="bx15"></div>
            <div className="bx16"></div>
            <div className="bx17"></div>
            <div className="bx18"></div>
            <div className="bx19"></div>
            <div className="bx20"></div>
            <div className="bx21"></div>
            <div className="bx22"></div>
            <div className="bx23"></div>
            <div className="bx24"></div>
            <div className="bx25"></div>
            <div className="bx26"></div>
            <div className="bx27"></div>
            <div className="bx28"></div>
            <div className="bx29"></div>
            <div className="bx30"></div>
            <div className="bx31"></div>
            <div className="bx32"></div>
            <div className="bx33"></div>
            <div className="bx34"></div>
            <div className="bx35"></div>
            <div className="bx36"></div>
            <div className="bx37"></div>
            <div className="bx38"></div>
            <div className="bx39"></div>
            <div className="bx40"></div>
            <div className="bx41"></div>
            <div className="bx42"></div>
            <div className="bx43"></div>
            <div className="bx44"></div>
            <div className="bx45"></div>
            <div className="bx46"></div>
            <div className="bx47"></div>
            <div className="bx48"></div>
            <div className="bx49"></div>
            <div className="bx50"></div>
            <div className="bx51"></div>
            <div className="bx52"></div>
            <div className="bx53"></div>
            <div className="bx54"></div>
            <div className="bx55"></div>
            <div className="bx56"></div>
            <div className="bx57"></div>
            <div className="bx58"></div>
            <div className="bx59"></div>
            <div className="bx60"></div>
            <div className="bx61"></div>
            <div className="bx62"></div>
            <div className="bx63"></div>
            <div className="bx64"></div>
            <div className="bx65"></div>
            <div className="bx66"></div>
            <div className="bx67"></div>
            <div className="bx68"></div>
            <div className="bx69"></div>
            <div className="bx70"></div>
            <div className="bx71"></div>
            <div className="bx72"></div>
            <div className="bx73"></div>
            <div className="bx74"></div>
            <div className="bx75"></div>
            <div className="bx76"></div>
            <div className="bx77"></div>
            <div className="bx78"></div>
            <div className="bx79"></div>
            <div className="bx80"></div>
            <div className="bx81"></div>
            <div className="bx82"></div>
            <div className="bx83"></div>
            <div className="bx84"></div>
            <div className="bx85"></div>
            <div className="bx86"></div>
            <div className="bx87"></div>
            <div className="bx88"></div>
            <div className="bx89"></div>
            <div className="bx90"></div>
            <div className="bx91"></div>
            <div className="bx92"></div>
            <div className="bx93"></div>
            <div className="bx94"></div>
            <div className="bx95"></div>
            <div className="bx96"></div>
            <div className="bx97"></div>
            <div className="bx98"></div>
            <div className="bx99"></div>
            <div className="bx100"></div>
          </div>
        </div>
        <div className="loginform">
          {/* 快速登入綁定後顯示區塊 */}
          {(Static.storageService.getDeviceLocklessKey() || Static.storageService.getDeviceKey()) ? <React.Fragment>
            <div className=" ">
              <IonList no-lines>
                <IonRow responsive-sm>
                  <IonCol>
                    <IonItem className="titleh3"><h3>快速登入</h3></IonItem>
                  </IonCol>
                </IonRow>
                <div className="floatbox custombtn">
                  {Static.storageService.getDeviceKey() &&
                    <IonButton shape="round" type="submit" className="i_biometric" onClick={(e) => this.logInFast_Device(e)}>臉部/指紋辨識</IonButton>
                  }
                  {Static.storageService.getDeviceLocklessKey() &&
                    <IonButton shape="round" type="submit" className="i_biometric_device" onClick={(e) => this.logInFast_DeviceLockless(e)}>設備辨識</IonButton>
                  }
                </div>
                <IonRow responsive-sm>
                  <IonCol></IonCol>
                  <IonCol className="centeral">
                    <IonButton className="linkstyle mt30" fill="clear" size="small" color="dark" onClick={(e) => this.unbindAll(e)}>
                      解除所有綁定
                    </IonButton>
                  </IonCol>
                  <IonCol></IonCol>
                </IonRow>
              </IonList>
            </div>
          </React.Fragment> : <React.Fragment>

            {/* <IonSegment mode="ios" value={selectedSegment} onIonChange={this.handleSegmentChange}>
              <IonSegmentButton mode="ios" value="default">
                <IonLabel>預設模式</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton mode="ios" value="accounttype">
                <IonLabel>帳密模式</IonLabel>
              </IonSegmentButton>
            </IonSegment> */}

            {/* 未綁定時顯示區塊 */}
            <div>
              <IonList no-lines>
                <IonItem>
                  <IonLabel position="floating">姓名</IonLabel>
                  <IonInput
                    name="username"
                    value={this.state.username}  //改成 用戶姓名
                    onInput={(e: any) => this.handleInputChange(e)}

                    //onIonChange={this.updateUserName}
                    type="text"
                    placeholder="輸入報名時的姓名"
                    autocapitalize="off"
                    required></IonInput>
                </IonItem>
                <IonItem>
                  <IonLabel position="floating">帳號</IonLabel>
                  <IonInput
                    name="password"
                    value={this.state.password}  //改成 Email 或 手機
                    onInput={(e: any) => this.handleInputChange(e)}
                    placeholder="台灣\手機不加國碼，海外\小寫Email"
                    type="text" required></IonInput>
                </IonItem>
              </IonList>
              <IonRow responsive-sm>
                <IonCol>
                  <IonButton expand="block" color="primary" onClick={e => this.logInDefault(e)} type="submit">
                    進入
                  </IonButton>
                </IonCol>
              </IonRow>
            </div>


            {/* {selectedSegment === 'default' && ()} */}
            {/* {selectedSegment === 'accounttype' && (
              <div>
                <IonList no-lines>
                  <IonItem>
                    <IonLabel position="floating">帳號</IonLabel>
                    <IonInput
                      name="email"
                      value={this.state.email}  //改成 用戶姓名
                      onInput={(e: any) => this.handleInputChange(e)}

                      //onIonChange={this.updateUserName}
                      type="text"
                      placeholder="輸入E-mail"
                      autocapitalize="off"
                      required></IonInput>
                  </IonItem>
                  <IonItem>
                    <IonLabel position="floating">密碼</IonLabel>
                    <IonInput
                      name="userpassword"
                      value={this.state.userpassword}  //改成 Email 或 手機
                      onInput={(e: any) => this.handleInputChange(e)}
                      placeholder="輸入密碼"
                      type="password" required></IonInput>
                  </IonItem>
                </IonList>
                <IonRow responsive-sm>
                  <IonCol>
                    <IonButton expand="block" color="primary" onClick={e => this.logInAccount(e)} type="submit">
                      進入
                    </IonButton>
                  </IonCol>
                </IonRow>
                <IonRow responsive-sm>
                  <IonCol size="4" offset="4">
                    <a href="/ForgotPassword">
                      <IonButton className="linkstyle" fill="clear" size="small" color="dark">
                        忘記密碼？
                      </IonButton>
                    </a>
                  </IonCol>
                </IonRow>
              </div>
            )} */}


          </React.Fragment>
          }


        </div>
      </>
    );
  }
}
